import type { Space } from '@cocoonspace/sdk-js/types/space'
import { cn } from '@cocoonspace/ui/lib/utils'
import { ExpandIcon } from 'lucide-react'
import type { ComponentProps } from 'react'

export const SpaceSurface = ({
	space,
	className,
	...props
}: { space: Pick<Space, 'surface'> } & ComponentProps<'div'>) => (
	<div
		className={cn('flex flex-row items-center', className)}
		data-testid='space-surface'
		{...props}
	>
		<ExpandIcon
			className='mr-1'
			size={14}
		/>

		{`${space.surface} m²`}
	</div>
)
